import React, { Component } from 'react';
import './App.css';
import { API_PATH, HOST_PATH } from './constants';
import List from './components/list';
import FullPost from './components/fullpost';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      data:'',
      postID : ''
    }

    this.fetchPostData = this.fetchPostData.bind(this);

  }

  componentDidMount(){

    const api_url = `${HOST_PATH}${API_PATH}`;
    fetch(api_url)
      .then(response => response.json())
      .then(data => this.setState({data}));

  }

  fetchPostData = (e) => {
    e.preventDefault();
    this.setState({
      postID : event.target.getAttribute('data-postid')
    })
  }


  render() {

    const {data, postID} = this.state;

    return (
      <div className="App">
        <div className="App-header">
          <img src="http://moodyfoody.dev-portal.com/wp-content/uploads/2019/08/ModdyFoddy.png" className="App-logo" alt="logo" />
        </div>
        <div className="body">

          <div className="section-left">
            <div className="post-result">
              { data &&
                <List onClick={this.fetchPostData} data={data}/>
              }
            </div>
          </div>
          <div className="section-right">
            <FullPost data={data} postid={postID}/>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js